<template>
  <section class="cta-section section">
    <div class="container">
      <div class="cta-box reveal">
        <div class="cta-bg-glow"></div>
        <h2>{{ $store.getters.t('cta.title') }}</h2>
        <p>{{ $store.getters.t('cta.desc') }}</p>
        <div class="cta-actions">
          <a :href="$store.getters.t('cta.demoLink')" target="_blank" class="btn btn-primary btn-lg">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polygon points="5 3 19 12 5 21 5 3"/></svg>
            {{ $store.getters.t('cta.demoBtn') }}
          </a>
          <a href="mailto:contact@elttec.com" class="btn btn-outline btn-lg">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            {{ $store.getters.t('cta.contactBtn') }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'CTASection' }
</script>

<style scoped>
.cta-section { padding: 0 0 100px; }
.cta-box {
  background: linear-gradient(135deg, rgba(20,35,55,.95), rgba(10,18,35,.98));
  border: 1px solid rgba(59,130,246,.12);
  border-radius: 28px;
  padding: 72px 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.cta-bg-glow {
  position: absolute;
  top: -30%;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 600px;
  background: radial-gradient(ellipse, rgba(59,130,246,.07) 0%, transparent 60%);
  pointer-events: none;
}
.cta-box > * { position: relative; z-index: 1; }
.cta-box h2 {
  font-size: clamp(26px, 4vw, 36px);
  font-weight: 800;
  color: #f1f5f9;
  margin-bottom: 14px;
  letter-spacing: -.01em;
}
.cta-box p {
  font-size: 16px;
  color: #94a3b8;
  margin-bottom: 40px;
  max-width: 560px;
  margin-left: auto;
  margin-right: auto;
}
.cta-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}
.cta-actions .btn {
  padding: 15px 36px;
  font-size: 15px;
  border-radius: 12px;
  gap: 10px;
}
@media (max-width: 768px) {
  .cta-box { padding: 48px 24px; }
  .cta-actions { flex-direction: column; align-items: center; }
}
</style>
